<template>
  <div
    class="d-inline-flex"
    @click.stop.prevent="emitClick"
  >
    <template>
      <i
        v-if="custom_icon"
        v-b-tooltip
        :class="fa_type + ' fa-' + custom_icon + ' fa-fw'"
        :data-testid="'icon-' + custom_icon"
        :style="stylingIcon"
        :title="tooltip"
      />
      <i
        v-else-if="iconDict[app_icon]"
        v-b-tooltip
        :class="fa_type + ' fa-' + iconDict[app_icon] + ' fa-fw'"
        :data-testid="'icon-' + iconDict[app_icon]"
        :style="stylingIcon"
        :title="tooltip"
      />
      <slot />
    </template>
  </div>
</template>
<script>
import { COLOR_DICT, ICON_DICT } from '@/constants/StyleMixin.constants'

export default {
  name: 'AppIcon',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    custom_icon: String,
    app_icon: String,
    fa_type: {
      type: String,
      default: 'far',
    },
    tooltip: String,
    icon_size: String,
    padding: String,
  },
  data() {
    return {
      iconDict: ICON_DICT,
    }
  },
  computed: {
    stylingIcon: function () {
      return {
        'font-size': this.icon_size ? this.icon_size : '1em',
        'font-weight': 400,
        color: COLOR_DICT[this.color],
      }
    },
  },
  methods: {
    emitClick(ev) {
      if (!this.disabled) {
        this.$emit('click', ev)
      }
    },
  },
}
</script>
